import { render, staticRenderFns } from "./IdentityList.vue?vue&type=template&id=259b6524&"
import script from "./IdentityList.vue?vue&type=script&lang=js&"
export * from "./IdentityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports